import { render } from "./LeadConfigSidebar.vue?vue&type=template&id=299b7f7d&scoped=true"
import script from "./LeadConfigSidebar.vue?vue&type=script&lang=js"
export * from "./LeadConfigSidebar.vue?vue&type=script&lang=js"

import "./LeadConfigSidebar.vue?vue&type=style&index=0&id=299b7f7d&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299b7f7d"]])

export default __exports__